module.exports = __webpack_public_path__ + "static/media/tw-mention.fdfa2486.svg";